import React, { FC } from "react";
import { Control } from "react-hook-form";

import YearBase, { YearBaseProps } from "@/components/ui/Form/Filters/components/Year/YearBase";
import YearControlled from "@/components/ui/Form/Filters/components/Year/YearControlled";

export interface YearProps extends YearBaseProps {
  control?: Control<any>;
}
const Year: FC<YearProps> = (args) => {
  return <>{args?.control ? <YearControlled control={args.control} {...args} /> : <YearBase {...args} />}</>;
};
export default Year;
